module.exports = "<label [ngClass]=\"{'input--grouped': grouped}\">\n    <span class=\"input__label\" *ngIf=\"label\">{{ label | translate }}</span>\n    <span class=\"input\">\n        <span *ngIf=\"icon\" [ngClass]=\"{'input__icon--reversed': reversed}\" class=\"input__icon\">\n            <i class=\"material-icons\">{{ icon }}</i>\n        </span>\n        <ng-content></ng-content>\n    </span>\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/components/form-control/form-control.component.html
// module id = 27
// module chunks = 0 1